//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @figma https://www.figma.com/file/raJ1JI1lfRDJ0ctGj7Rpgf/hse_icons_library?node-id=1%3A2
 * @storybook /?path=/story/icons-icon--playground
 * @react /src-components-icon
 * @reactStorybook /?path=/story/icons-icon--playground
 */
var script = {
  name: 'HseIcon',
  props: {
    /**
     * Размер иконки
     * @values small, medium, large
     */
    size: {
      type: String,
      validator: v => ['small', 'medium', 'large'].includes(v),
      default: 'small'
    },
    /**
     * Иконка
     * @values Компонент иконки или название зарегистрированного
     */
    icon: {
      type: [String, Object],
      default: null
    },
    /**
     * Цвет иконки
     */
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconStyle() {
      const { color } = this;
      return color ? { color } : { };
    }
  }
};

export default script;
